<template>
  <div>
    <div class="panel">
      <el-table size="small" border :data="pdcs" style="width: 100%">
        <el-table-column
          align="center"
          prop="option_time"
          label="时间"
        ></el-table-column>
        <el-table-column align="center" prop="numbers" label="序列号"
          ><template slot-scope="scope">
            <div v-for="n in scope.row.numbers" :key="n">{{ n }}</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="code"
          label="编码"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="specification"
          label="规格"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="model_number"
          label="倒角"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="tooth_type"
          label="齿形"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="size"
          label="尺寸"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="number"
          label="数量"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { drillPdcInfo } from '@/service/getData'
export default {
  props: {
    serialNumber: String,
  },
  data() {
    return {
      pdcs: [],
    }
  },
  watch: {
    serialNumber() {
      this.getData()
    },
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await drillPdcInfo(this.serialNumber)
      if (res.status == 0) {
        this.pdcs = res.data.pdc_records.map((pdc) => {
          let arr = pdc.drill_serial_numbers.split(',')
          let query = res.data.serial_number.substring(
            0,
            res.data.serial_number.length - 1
          )
          var numbers = []
          for (var j = 0; j < arr.length; j++) {
            let number = arr[j].substring(0, arr[j].length - 1)
            if (number == query) {
              numbers.push(arr[j])
            }
          }
          pdc.numbers = numbers
          pdc.number = Math.round(pdc.number / arr.length)
          if (pdc.number == 0) {
            pdc.number = 1
          }
          return pdc
        })
      } else {
        this.pdcs = []
      }
    },
  },
}
</script>